<template>
  <div class="home" data-scroll-container>
    <TheHeader />
    <component :is="MVComponent" />
    <HomeProduct />
    <InterviewList />
    <Credit />
    <Product />
    <TheFooter />
  </div>
</template>

<script>
import imagesLoaded from 'imagesloaded'

import { mapState } from 'vuex'

import HomeMV from '@/components/HomeMV.vue'
import HomeMVSP from '@/components/HomeMVSP.vue'
import HomeProduct from '@/components/HomeProduct.vue'
import InterviewList from '@/components/InterviewList.vue'
import Credit from '@/components/Credit.vue'
import Product from '@/components/Product.vue'

/* global */
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'

/* mixin */
import locomotive from '@/mixins/locomotive.js'

export default {
  name: 'home',

  metaInfo() {
    return {
      title: 'OCEANTRICO JET',
      titleTemplate: null,
      meta: [
        {
          property: 'og:title',
          content: 'OCEANTRICO JET'
        },
        {
          name: 'description',
          content:
            'OCEAN TRICO史上、"最強"のハードワックスとして登場したJET。10月に解禁されたビジュアルでは、いまもっとも勢いをもって活躍する3組のプロフェッショナルをモデルとして起用した。彼らは日々、ハードな環境と向き合いながら、“最強”であり続けている。その裏側では、絶え間なき努力や葛藤があったはずだ。このスペシャルインタビューでは、そういった彼らの内面に向き合いながら、彼らが“最強”であり続ける所以を紐解いていく。'
        },
        {
          property: 'og:description',
          content:
            'OCEAN TRICO史上、"最強"のハードワックスとして登場したJET。10月に解禁されたビジュアルでは、いまもっとも勢いをもって活躍する3組のプロフェッショナルをモデルとして起用した。彼らは日々、ハードな環境と向き合いながら、“最強”であり続けている。その裏側では、絶え間なき努力や葛藤があったはずだ。このスペシャルインタビューでは、そういった彼らの内面に向き合いながら、彼らが“最強”であり続ける所以を紐解いていく。'
        },
        {
          property: 'og:image',
          content: `https://oceantrico.com/jet/share/ogp.jpg`
        },
        {
          name: 'twitter:image',
          content: `https://oceantrico.com/jet/share/ogp.jpg`
        }
      ]
    }
  },
  mixins: [locomotive],
  components: {
    TheHeader,
    HomeMVSP,
    HomeMV,
    HomeProduct,
    InterviewList,
    Credit,
    Product,
    TheFooter
  },

  computed: {
    ...mapState(['isMobile']),
    MVComponent() {
      const isMobile = window.innerWidth <= 750
      return isMobile ? 'HomeMVSP' : 'HomeMV'
    }
  },

  mounted() {
    const { commit } = this.$store

    this.$nextTick(() => {
      const firstViewImgLoad = new imagesLoaded(
        this.$el.querySelector('.js-first-view')
      )
      firstViewImgLoad.on('always', (inst) => {
        commit('loaded')
      })

      const imgLoad = new imagesLoaded(this.$el)
      imgLoad.on('always', () => {
        if (window.lmS) {
          this.$nextTick(() => {
            window.lmS.update()
          })
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const color = entry.target.getAttribute('data-logo-color')
                commit('logoColorChange', color)
              } else {
                commit('logoColorChange', 'white')
              }
            })
          },
          { threshold: [0.2, 0.7] }
        )

        document.querySelectorAll('.js-color-change').forEach((el) => {
          this.observer.observe(el)
        })
        // commit('loaded')
      })
    })
  },

  beforeDestroy() {
    document.querySelectorAll('.js-color-change').forEach((el) => {
      this.observer.unobserve(el)
    })
  }
}
</script>
